import { configureStore } from '@reduxjs/toolkit'
import drawerRightReducer from './slices/Drawer/drawerRight'
import drawerLeftReducer from './slices/Drawer/drawerLeft'
import modalConfirmation from './slices/Modal/modalBoxConfirmation'
import modalCodeQRReducer from './slices/Modal/modalCodeQR'
import modalDeleteRecReducer from './slices/Modal/modalDeleteRecord'
import enableButton from './slices/Modal/enableButton'
import treeFeaturesReducer from './slices/Tree/treeFeatures'
import mapStateReducer from './slices/Map/map'
import loginReducer from './slices/Auth/login'
import filterSearchReducer from './slices/Search/input'
import reportReducer from './slices/Report/reportSlice'
import alertsReducer from './slices/Alerts'

export const store = configureStore({
  reducer: {
    drawerRight: drawerRightReducer,
    drawerLeft: drawerLeftReducer,
    modalConfirmation: modalConfirmation,
    modalRemoveTree: modalDeleteRecReducer,
    enableButton: enableButton,
    modalCodeQr: modalCodeQRReducer,
    treeFeatures: treeFeaturesReducer,
    mapState: mapStateReducer,
    login: loginReducer,
    filterSearch: filterSearchReducer,
    report: reportReducer,
    alertsGlobal: alertsReducer,
  },
})
